import { render } from "./timeago.vue?vue&type=template&id=0a9ecf4c"
import script from "./timeago.vue?vue&type=script&lang=js"
export * from "./timeago.vue?vue&type=script&lang=js"

import "./timeago.vue?vue&type=style&index=0&id=0a9ecf4c&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__